/**
 * Types new imagery can be requested for, upper-case as the request table and
 * the scheduler spell them. Yara's NDVI, biomass (S1) and N-Uptake (SN); NDVI
 * stays first, the maps panel's header button sends it. The fixed-scale variant
 * is not one: it is made alongside every NDVI image, never requested on its own.
 *
 * Shared by the maps imagery panel and the legacy MapDataFarm/MapDataField
 * dialogs, so the screens cannot drift apart.
 */
export const REQUESTABLE_IMAGERY_TYPES = ['YARA NDVI SATELLITE', 'S1 SATELLITE', 'SN SATELLITE'];

/** Exact match, as the legacy screens always used, rather than a substring test. */
export function isRequestableImageryType(type: string | null | undefined): boolean {
  return REQUESTABLE_IMAGERY_TYPES.includes((type || '').toUpperCase());
}
